import { call, cancel, fork, put, take } from "redux-saga/effects"

import {
  CALLS_GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA as GET_DASHBOARD_DATA, LEADS_GET_DASHBOARD_DATA,

} from "./actionTypes"

import {
  getCallsDashboardDataError,
  getCallsDashboardDataSuccess,
  getDashboardDataError as getDashboardDataError,
  getDashboardDataSuccess as getDashboardDataSuccess,
  getLeadsDashboardDataError,
  getLeadsDashboardDataSuccess,

} from "./actions"

import { SfPostRequest
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"
import _ from "lodash"

function* onGetDashboardData(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    let endpoint = '/api/v1/dashboards'
    const query_params = payload?.payload
    if (payload.v3_conversions_api && query_params?.fetch_conversion_pixel_wise_metrics == 1) {
      endpoint = '/api/v3/dashboards'
    }
    else if (payload.v3_api && query_params?.fetch_conversion_pixel_wise_metrics != 1
    ) {
      endpoint = '/api/v3/dashboards'
    }
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )

    yield put(getDashboardDataSuccess(response, payload.api_type))
  } catch (error) {
    yield put(getDashboardDataError(error, payload.api_type))
  }
}

function* onGetDashboardDataLeads(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")

    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/dashboard/leads/${payload.api_type.replace("leads_", '')}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )

    yield put(getLeadsDashboardDataSuccess(response, payload.api_type))
  } catch (error) {
    yield put(getLeadsDashboardDataError(error, payload.api_type))
  }
}


function* onGetDashboardDataCalls(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")

    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/dashboard/calls/${payload.api_type.replace("calls_", '')}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )

    yield put(getCallsDashboardDataSuccess(response, payload.api_type))
  } catch (error) {
    yield put(getCallsDashboardDataError(error, payload.api_type))
  }
}

const customTakeLatest = (patternOrChannel, saga, ...args) => fork(function*() {
  let lastActionTasks = [];
  while (true) {
    const action = yield take(patternOrChannel);
    const actionType = action.type + '_' + action.api_type;
    const tasksToCancel = _.remove(lastActionTasks, (o) => {
      return (o.type === actionType)
    });
    for (const task of tasksToCancel) {
      yield cancel(task.task)
    }
    const task = yield fork(saga, ...args.concat(action))
    lastActionTasks.push({ type: actionType, task: task })
  }
})

function* DashboardSaga() {
  yield customTakeLatest(GET_DASHBOARD_DATA, onGetDashboardData)
  yield customTakeLatest(LEADS_GET_DASHBOARD_DATA, onGetDashboardDataLeads)
  yield customTakeLatest(CALLS_GET_DASHBOARD_DATA, onGetDashboardDataCalls)

}

export default DashboardSaga
